import React from 'react';
import { Camera, FileImage, FileText, Paperclip, Lightbulb, AlertTriangle, MessageSquare } from 'lucide-react';
import Card from '../../../components/Card/Card';
import SectionHeader from '../../../components/SectionHeader/SectionHeader';

function ScanAnnexeTab() {
  return (
    <>
      {/* Section: Qu'est-ce que l'annexe */}
      <Card className="card-large">
        <SectionHeader icon={FileText} title="L'annexe, c'est quoi ?" variant="default" />
        <div className="guide-section-content">
          <div className="guide-info">
            <Paperclip className="guide-info-icon" size={20} />
            <p>
              L'annexe est une zone où vous pouvez ajouter du contenu supplémentaire à votre rapport :
              <strong> résultats d'examens, liste de médicament, antécédants, etc.</strong>.
              Ce contenu peut être utilisé par l'IA selon vos instructions.
            </p>
          </div>
        </div>
      </Card>

      {/* Section: Scanner un document */}
      <Card className="card-large">
        <SectionHeader icon={Camera} title="Scanner un document" variant="info" />
        <div className="guide-section-content">
          <div className="guide-steps">
            <div className="guide-step">
              <span className="guide-step-number">1</span>
              <div className="guide-step-content">
                <h4>Appuyez sur l'icône appareil photo</h4>
                <p>Dans le dictaphone, cliquez sur le bouton caméra.</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">2</span>
              <div className="guide-step-content">
                <h4>Prenez une photo ou importez un fichier</h4>
                <p>Photographiez un document ou importez depuis vos fichiers (PDF, image, Word).</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">3</span>
              <div className="guide-step-content">
                <h4>Le texte est extrait automatiquement</h4>
                <p>Le texte de l'image est lu et ajouté à votre annexe.</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Section: Important - Dire au modèle */}
      <Card className="card-large">
        <SectionHeader icon={AlertTriangle} title="Important : guidez l'IA" variant="warning" />
        <div className="guide-section-content">
          <div className="guide-warning">
            <AlertTriangle className="guide-warning-icon" size={20} />
            <p>
              <strong>L'IA n'utilise pas l'annexe automatiquement.</strong> Vous devez lui dire
              comment l'utiliser dans votre dictée, sinon elle ne la touchera pas.
            </p>
          </div>
          <div className="guide-tip">
            <Lightbulb className="guide-tip-icon" size={20} />
            <p>
              Exception : certains modèles spéciaux comme <strong>"Annexe"</strong> sont conçus
              pour traiter directement le contenu de l'annexe sans instruction particulière.
            </p>
          </div>
        </div>
      </Card>

      {/* Section: Exemples d'utilisation */}
      <Card className="card-large">
        <SectionHeader icon={MessageSquare} title="Exemples d'utilisation" variant="success" />
        <div className="guide-section-content">
          <div className="guide-steps">
            <div className="guide-step">
              <span className="guide-step-number">1</span>
              <div className="guide-step-content">
                <h4>Antécédents du patient</h4>
                <p>"En annexe la liste des antécédents, merci de les intégrer dans le rapport."</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">2</span>
              <div className="guide-step-content">
                <h4>Résultats de laboratoire</h4>
                <p>"J'ai scanné les résultats de labo en annexe, merci de les résumer dans la conclusion."</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">3</span>
              <div className="guide-step-content">
                <h4>Ancien compte-rendu</h4>
                <p>"En annexe l'écho précédente, merci de comparer avec les nouvelles mesures."</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">4</span>
              <div className="guide-step-content">
                <h4>Courrier d'un confrère</h4>
                <p>"Le courrier du Dr Martin est en annexe, merci d'y répondre."</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Section: Types de fichiers */}
      <Card className="card-large">
        <SectionHeader icon={FileImage} title="Formats acceptés" variant="default" />
        <div className="guide-section-content">
          <div className="guide-features">
            <div className="guide-feature">
              <div className="guide-feature-icon cyan">
                <FileImage size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Images</h4>
                <p>JPG, PNG, HEIC - photos de documents</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon primary">
                <FileText size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>PDF</h4>
                <p>Documents PDF avec extraction de texte</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon blue">
                <FileText size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Word</h4>
                <p>Documents .docx</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon gray">
                <FileText size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Texte</h4>
                <p>Fichiers .txt simples</p>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}

export default ScanAnnexeTab;
